const DONATION_WAY_TO_DONATION_GA_INFO = {
  '信用卡定期定額': {
    'item': {
      'item_id': 'PERIOD_DONATION',
      'item_name': '定期定額',
    },
    'payment_type': '信用卡',
  },
  'ATM轉帳繳款': {
    'item': {
      'item_id': 'SINGLE_DONATION',
      'item_name': '單筆捐款',
    },
    'payment_type': '綠界ATM轉帳繳款',
  },
  '超商代碼繳款': {
    'item': {
      'item_id': 'SINGLE_DONATION',
      'item_name': '單筆捐款',
    },
    'payment_type': '綠界超商代碼繳款',
  },
  'LINE Pay': {
    'item': {
      'item_id': 'SINGLE_DONATION',
      'item_name': '單筆捐款',
    },
    'payment_type': 'LINE Pay',
  },
  '信用卡單次繳款': {
    'item': {
      'item_id': 'SINGLE_DONATION',
      'item_name': '單筆捐款',
    },
    'payment_type': '綠界信用卡單次繳款',
  },
  '街口支付單次捐款': {
    'item': {
      'item_id': 'SINGLE_DONATION',
      'item_name': '單筆捐款',
    },
    'payment_type': '街口支付',
  },
};

export {
  DONATION_WAY_TO_DONATION_GA_INFO,
};

